// 自分を含まない先祖のリスト
export const getAncestorTagList = (allTags, targetTagId, acc = []) => {
  const getAncestorTagsRecursively = (allTags, tagId, acc = []) => {
    const tag = allTags.find((tag) => tag.id === tagId);
    if (tag === undefined) {
      return acc;
    }
    const nextAcc = [tag, ...acc];
    return getAncestorTagsRecursively(allTags, tag.parent_id, nextAcc);
  };

  const targetTag = allTags.find((tag) => tag.id === targetTagId);
  if (targetTag) {
    return getAncestorTagsRecursively(allTags, targetTag.parent_id);
  }
  return [];
};

// 自分を含まない先祖の長さ
export const getAncestorTagsLength = (allTags, targetTagId) => {
  return getAncestorTagList(allTags, targetTagId).length;
};

// 自分を含まない最長の子孫の長さ
export const getLongestDescendantsNum = (allTags, targetTagId, long = 0) => {
  const childrenTags = allTags.filter((tag) => tag.parent_id === targetTagId);
  if (childrenTags.length === 0) {
    return long;
  }
  const childrenLongestDescendants = childrenTags.map((tag) =>
    getLongestDescendantsNum(allTags, tag.id, long + 1)
  );

  return Math.max(...childrenLongestDescendants);
};
